<template>
  <div class="invite" :style="'background-image:url('+img.pagebg+');height:'+winHeight+'px;background-size: 100% '+winHeight+'px;'">
    <div class="div_mask">
      <div class="f-14" style="color: #cccccc;padding: 10px 36px;padding-top: 20px;">受邀人信息</div>
      <div class="input_bg">
        <van-field
        v-model="textcontent"
        rows="3"
        autosize
        label="履历展示"
        type="textarea"
        placeholder=""
        @input="inputText"
        @blur="inputblur"
        :focus="inputfocus"
        ref="inputTag"
        style="padding:10px 36px;"
        >
        <template #button v-if="showplaceholder">
          <div style="color: #A3A3A3;" @click="clickInput">请输入精彩履历，如：</div>
          <div style="color: #A3A3A3;" @click="clickInput">资深Subie</div>
          <div style="color: #A3A3A3;" @click="clickInput">俱乐部/车友会创始人</div>
          <!-- <div class="hand_box" @click="clickInput">
            <img class="hand_gif" :src="img.hand_gif">
          </div> -->
        </template>
      </van-field>
      <div class="f-14" style="color: #ffffff;padding: 15px 36px 25px;">展示效果</div>
    </div>
    <div class="info">
      <span class="headbox">
        <img class="head" :src="otherinfo.avatar&&otherinfo.avatar.substring(0,5)=='https' ? otherinfo.avatar : img.avatar">
        <img class="headsficon" :src="img.border">
      </span>
     <!--  <span>
        <van-button class="follow buttonin" icon="plus" color="#1E2A75" size="small">关 注</van-button>
      </span> -->
      <div class="f-14 f-w" style="color: #1E2A75;margin-bottom: 20px;margin-top: 20px;">{{otherinfo.username}}</div>
      <div class="f-12" style="color:#979797;" v-if="list.length>0">
        <img class="member_car" :src="img.sficon">
        <span v-for="(item,index) in list" :key="'list_' + index" :style="index>0?'display: block;margin-left:18px;':''">{{item}}</span>
      </div>
      <div class="f-12" style="color: #979797;margin-top: 5px;" v-if="otherinfo.cars"><img class="member_car" :src="img.member_car">{{otherinfo.cars.title}} 车主</div>
    </div>
    <div class="carbtn" @click="goCarapprove" v-if="!inputfocus">车主认证</div>
    <div class="nextStep" @click="nextStep" v-if="!inputfocus">跳过
      <img class="nextimg" :src="img.nextimg">
    </div>
  </div>
</div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon} from 'vant';
  export default {
    data () {
      return {
        winHeight:568,
        otherinfo:'',
        textcontent:'',
        source:1,
        list:['资深Subie','俱乐部/车友会创始人'],
        inputfocus:false,
        showplaceholder:true,
        docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
        showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        value:'',
        img:{
          avatar:require('../../../assets/img/lexus/default.png'),
          sficon: require('../../../assets/img/subaru/approve/newicon.png'),
          lexus: require('../../../assets/img/subaru/approve/qrcode.png'),
          border: require('../../../assets/img/subaru/border.gif'),
          pagebg:require('../../../assets/img/subaru/approve/approve_bg.png'),
          member_car: require('../../../assets/img/subaru/member_car.png'),
          nextimg: require('../../../assets/img/lexus/approve/nextimg.png'),
          hand_gif: require('../../../assets/img/hand_gif.gif'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    mounted() {
      window.onresize = () => {
       return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.showHeight = window.fullHeight;
      })()
    };
  },
  watch: {
    showHeight (val) {
      let that = this;
      that.show2 = true;
      if (that.docmHeight > val){
        that.inputfocus=true
      } else{
        setTimeout(function(){
          that.inputfocus=false
        },100)
      }
    }
  }, 
  created () {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.winHeight=h
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: false})
    this.$appService.isTabbar({state: true})
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    if(this.$route.query.token){
      this.source = this.$route.query.source
      this.token = this.$route.query.token
      this.user_id = this.$route.query.userid
      this.$store.dispatch('param/setToken', this.$route.query.token)
      this.getUserOther(this.$route.query.userid)
      this.getActivity(this.$route.query.userid)
    }else{
      this.source = this.$route.params.source
      this.token = this.$route.params.token
      this.$store.dispatch('param/setToken', this.$route.params.token)
      this.user_id = this.$route.params.user_id
      this.getActivity(this.$route.params.user_id)
      this.getUserOther(this.$route.params.user_id)
    }
    var params={
      event_code: '邀请认证',
      event_id: '',
      title: '',
      value: '',
      path: '/Subaru/Approve/SubaruInvite.vue',
      user_id: this.user_id ? this.user_id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){

      }
    })
  },
  methods: {
    getUserOther(id){
      var params={
        user_id:parseInt([id]),
        source:this.source
      }
      member.userOther(params).then(res => {
        if(res.data.state==1){
          this.otherinfo=res.data.data
        }
      })
    },
    getActivity(id){
      var params={
        user_id:parseInt([id]),
      }
      common.getActivity(params,12).then(res => {
        if(res.data.state==1){
          this.activeinfo=res.data.data
          this.img.lexus=res.data.data.enroll_share_pic
          if(res.data.data.background_pic){
            this.img.pagebg=res.data.data.background_pic
          }
        }
      })
    },
    goCarapprove(){
      if(this.source==5){
        if(this.textcontent){
          wx.miniProgram.navigateTo({url:'/pages/approve/approve?textcontent='+this.textcontent})
        }else{
          this.$toast('请填写履历展示')
        }
      }else{
        var params={
          url:this.weburl+'/subaru/my/approve?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    nextStep(){
      if(this.source==5){
        if(this.textcontent){
          var params={
            hid:12,
            other:this.textcontent,
            car_id:'',
            car_model_name:'',
            source:this.source
          }
          common.activeApply(params).then(res => {
            if(res.data.state==1){
              this.otherinfo=res.data.data
              wx.miniProgram.reLaunch({url: '/pages/webview/webview?scene=https://m.motortime.com/subaru/inviteok'})
                // this.$router.push({name:'LexusInviteok',params:{source:this.source,token:this.token,user_id:this.user_id}});
              }
            })

        }else{
          this.$toast('请填写履历展示')
        }

      }else{
        var params={
          url:this.weburl+'/subaru/inviteok?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    inputText(value){
      var value=value
      if(value){
        var list=value.split('\n');
        this.list=list
      }else{
        this.list=[]
      }
    },
    clickInput(){
      this.showplaceholder=false
      this.$refs.inputTag.focus()
      this.inputfocus=true
    },
    inputblur(){
      var that=this
      var list=that.list
      setTimeout(function(){
        that.inputfocus=false
      },100)
      if(that.textcontent){

      }else{
          // if(this.list.length==0){
            that.showplaceholder=true
            that.list=['资深Subie','俱乐部/车友会创始人']
          // }
        }
        
        
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Icon.name]:Icon
    }
  }
</script>
<style lang="scss">
.invite{
  width: 100%;
  background-color: #000;
  .div_mask{
    width: 100%;
    height: 100%;
      // background: rgba(0,0,0,.8);
    }
    .input_bg{
      background-color:rgba(0, 0, 0, 0.5);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      margin:0 15px -10px;
    }
    .van-field__label{
      color: #ffffff;
    }
    .van-field__button{
      text-align: left;
      position:absolute;
    }
    .van-field__control{
      color: #fff;
    }
    .van-cell{
      color: #A3A3A3;
      background:transparent;
    }
    .hand_box{
      position: absolute;
      top: 20px;
      left: 20px;
      .hand_gif{
        width: 64px;
        height: 64px;
      }
    }
    .info{
      position: absolute;
      left: 15px;
      right: 15px;      
      min-height: 150px;
      z-index: 99;
      background-color: #fff;
      border-radius: 8px;
      padding:20px;
      box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
      .headbox{
        position: relative;
        width: 60px;
        height: 60px;

      }
      .head{
        width: 60px;
        height: 60px;
        border-radius:60px;
      }
      .headsficon{
        width: 60px;
        height: 60px;
        position: absolute;
        // bottom: 7px;
        right: 0px;
      }
      .buttonin{
        float: right;
        margin-top: 15px;
      }
      .van-button--small{
        height: 28px;
        padding: 0 8px;
        line-height: 20px;
        border-radius: 8px;
        vertical-align: middle;
      }
      .van-button__icon{
        font-size: 10px;
      }
      .van-button__text{
        font-size: 11px;
      }
      .member_car{
        width: 15px;
        height: 15px;
      }
    }
    .carbtn{
      font-size: 14px;
      text-align: center;
      background: #1E2A75;
      color: #fff;
      padding:15px 30px;
      position: fixed;
      top: 73%;
      left: 34%;
      border-radius: 8px;
    }
    .nextStep{
      color: #999999;
      font-size: 14px;
      text-align: center;
      position: fixed;
      top: 83%;
      left: 44%;
      .nextimg{
        width: 13px;
        height:12px;
      }
    }
  }
</style>
